/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationTradeMicroGoalConfigQueryVariables = {
    itemId?: string | null;
    userId?: string | null;
    buyerId?: ReadonlyArray<string | null> | null;
};
export type pdpSharedNotificationTradeMicroGoalConfigQueryResponse = {
    readonly viewer: {
        readonly transactions: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly checkoutDate: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly conversationsSolr: {
            readonly totalResults: number | null;
        } | null;
        readonly item: {
            readonly canBuyerMakeOffer: boolean | null;
            readonly displayInfo: {
                readonly ctas: {
                    readonly showRequestOnApproval: boolean | null;
                    readonly showHoldRequest: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type pdpSharedNotificationTradeMicroGoalConfigQuery = {
    readonly response: pdpSharedNotificationTradeMicroGoalConfigQueryResponse;
    readonly variables: pdpSharedNotificationTradeMicroGoalConfigQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "buyerId",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "buyerId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "checkoutDate desc"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "checkoutDate",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v4 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "conversationsSolr",
  "storageKey": null,
  "args": [
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "concreteType": "ConversationsSolrConnection",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = [
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "pageType",
    "value": "PDP"
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canBuyerMakeOffer",
  "args": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayInfo",
  "storageKey": null,
  "args": [
    (v3/*: any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "pdp"
    }
  ],
  "concreteType": "ItemDisplayInfo",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "ctas",
      "storageKey": null,
      "args": null,
      "concreteType": "CTADisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRequestOnApproval",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showHoldRequest",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v6/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TransactionEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v6/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v9/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
    "id": "app-buyer-finding/237.0.0-2019-10-16T15:08:56.780Z/pdpSharedNotificationTradeMicroGoalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'e66940b62d17c074921b78518e075731';
export default node;
